import { CTATheme, Icon } from '../../utils'
import { DefaultSizeOptions, SizeOptions } from '../Text'

export { CTALink } from './element'

export interface ICTAData {
  text: string
  url: string
  newWindow?: boolean
  eventContext?: string
  eventObjectName?: string
  openMessenger?: boolean
  preloadedMessengerText?: string
  forwardQueryParams?: boolean
  surveyId?: number
  customBotId?: number
}

export interface IProps extends ICTAData {
  arrow?: boolean
  bgColor: CTATheme
  small?: boolean
  dataAttribute?: string
  wide?: boolean
  textSize?: SizeOptions | DefaultSizeOptions
  anchorRef?: React.RefObject<HTMLAnchorElement>
  icon?: Icon
  onClick?: () => void
}
